import { Box, Divider, Typography } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../../../assets/close-red.svg';
import { ReactComponent as ViewIcon } from '../../../../../../assets/view.svg';
import { CalendarService } from '../../../../../../service/calendar.service';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import { fetchAllAccounts } from '../../../../../../store/slices/calendarSlice';
import zeplinColor from '../../../../../../theme/Color';
import { getExternalCalendarUrl } from '../../../../../../utilities/CalendarUtils';
import { CALENDAR_PALETTE } from '../../../../../../utilities/constants';
import CustomPopOver from '../../../../../shared/CustomPopOver/CustomPopOver';

interface SettingsMenuProps {
  anchorEl: HTMLImageElement | null;
  onClose: () => void;
  calendarDetails: any;
  modalDispatch: React.Dispatch<any>;
}

export const CalendarSettingsMenu = ({
  anchorEl,
  onClose,
  calendarDetails,
  modalDispatch,
}: SettingsMenuProps) => {
  const dispatch = useAppDispatch();
  const colors = useAppSelector((state) => state.calendar.colors);
  const isHuddle = !['google', 'zoom', 'microsoft'].includes(calendarDetails?.type?.toLowerCase());

  const handleColorClick = async (color: string) => {
    try {
      const { title, type, value } = calendarDetails;
      await CalendarService.editCalendarAccount(title, {
        accountType: type === 'microsoft' ? 'ms_teams' : type,
        color,
      });
      dispatch(fetchAllAccounts());
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  const handleAction = (type: 'rename' | 'disconnect') => {
    modalDispatch({ type: 'OPEN', payload: type });
    onClose();
  };

  return (
    <CustomPopOver
      onClick={(e: any) => {
        e.stopPropagation();
      }}
      setAnchorEl={onClose}
      anchorEl={anchorEl}
      id={'simple-popover'}
      sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '16px',
        }}
      >
        {!isHuddle && (
          <a
            href={getExternalCalendarUrl(calendarDetails?.type)}
            target='_blank'
            rel='noopener noreferrer'
            style={{ textDecoration: 'none' }}
          >
            <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
              <ViewIcon width={18} height={18} />
              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                Open{' '}
                {calendarDetails?.type === 'google'
                  ? 'Google Calendar'
                  : calendarDetails?.type?.toUpperCase()}
              </Typography>
            </Box>
          </a>
        )}
        <Box
          sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
          onClick={() => {
            handleAction('rename');
          }}
        >
          <img src={'/assets/edit.svg'} style={{ width: '18px', height: '18px' }} alt='edit' />
          <Typography variant='responsiveBody3'>Rename Calendar</Typography>
        </Box>

        {!isHuddle && (
          <Box
            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
            onClick={(e) => {
              handleAction('disconnect');
            }}
          >
            <CloseIcon width={18} height={18} />
            <Typography variant='responsiveBody3' color={zeplinColor.Error}>
              Disconnect
            </Typography>
          </Box>
        )}

        <Divider sx={{ borderColor: zeplinColor.Neutral5 }} />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6,1fr)',
            gap: '8px',
            cursor: 'pointer',
          }}
        >
          {CALENDAR_PALETTE.map((color) => {
            console.log(calendarDetails?.color, color, 'color');
            return (
              <Box
                key={color}
                sx={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '6px',
                  backgroundColor: color,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => handleColorClick(color)}
              >
                {calendarDetails?.color === color && (
                  <img src={'/assets/tick-white.svg'} style={{ width: '12px' }} alt='selected' />
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    </CustomPopOver>
  );
};
